var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fade-in-fwd my-project-modal" }, [
    _c("div", { staticClass: "fade-in-fwd mt-2" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c("label", { attrs: { for: "" } }, [
            _vm._v(
              _vm._s(
                _vm.$resourceString[
                  "myProject.Project.AddItemModal.ProductStep1.ProjectGridSize.Label"
                ]
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-4" },
          [
            _c("my-project-radio-field", {
              attrs: {
                options: _vm.getContentWizardData.radioOptions,
                name: "size"
              },
              model: {
                value: _vm.getContentItem.size,
                callback: function($$v) {
                  _vm.$set(_vm.getContentItem, "size", $$v)
                },
                expression: "getContentItem.size"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group mt-2" },
        [
          _c(
            "label",
            { staticClass: "gray-bold", attrs: { for: "#Step2Description" } },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$resourceString[
                      "contentWizard.VirtualTray.TrayDescription.Label"
                    ]
                  ) +
                  "\n        "
              ),
              _c("span", { staticClass: "optional-field ml-3" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$resourceString["contentWizard.Label.Field.Optional"]
                    ) +
                    " "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("my-project-description-field", {
            attrs: {
              customClass: "form-control",
              maxlength: "400",
              fieldId: "description",
              placeholder:
                _vm.$resourceString[
                  "myProject.ProductItem.Description.Placeholder"
                ]
            },
            model: {
              value: _vm.getContentItem.description,
              callback: function($$v) {
                _vm.$set(_vm.getContentItem, "description", $$v)
              },
              expression: "getContentItem.description"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }